import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-admin-proveedores',
  templateUrl: './menu-admin-proveedores.component.html',
  styleUrls: ['./menu-admin-proveedores.component.scss']
})
export class MenuAdminProveedoresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
